import * as React from 'react';
import { Skeleton } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const Loader = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "myaccount-menu-loader"
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        "data-t": "myaccount-menu-loader",
        height: 16,
        width: "100%",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "16",
        rx: "5",
        fill: "currentColor"
    })));
};

export { Loader as default };
//# sourceMappingURL=Loader.js.map
